import React, { useEffect, useState } from 'react'
import { KeyboardAvoidingView, StyleSheet, Text, TextInput, TouchableOpacity, View, Image } from 'react-native'
import { Input, Button } from 'native-base'
import { useNavigation } from '@react-navigation/core'
import { auth, db } from '../firebase'
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth'
import { setDoc, doc } from 'firebase/firestore'
import { useRecoilValue } from 'recoil'
import { userState } from '../state/atoms'
import { FontAwesome } from '@expo/vector-icons'

const ForgotPasswordScreen = () => {
    // Local State
    const [email, setEmail] = useState('')

    // Global State
    const userDataTemplate = useRecoilValue(userState)

    const navigation = useNavigation()

    // Removes listener once signed in
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                navigation.replace('MainContainer')
            }
        })
        return unsubscribe
    }, [])

    return (
        <KeyboardAvoidingView style={styles.container} behavior="padding">
            <Image style={styles.homeLogo} source={require('../assets/logos/ZHOnly.png')} />
            <View style={styles.inputContainer}>
                <Input style={styles.emailField} autoCompleteType="emailAddress" autoCapitalize="none" keyboardType="email-address" autoCorrect={false} placeholder="Enter Email" value={email} onChangeText={(text) => setEmail(text)} />
            </View>
            <View style={styles.buttonContainer}>
                <TouchableOpacity style={styles.button}>
                    <Text style={styles.buttonText}>Send Email</Text>
                </TouchableOpacity>
                <TouchableOpacity style={styles.buttonOutline} onPress={() => navigation.navigate('Login')}>
                    <Text style={styles.buttonOutlineText}>Back to Sign in</Text>
                </TouchableOpacity>
            </View>
        </KeyboardAvoidingView>
    )
}

export default ForgotPasswordScreen

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    inputContainer: {
        width: '80%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    emailField: {
        backgroundColor: '#fff',
        borderRadius: 5,
        height: 50,
        fontSize: 16,
    },
    buttonContainer: {
        width: '80%',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20,
    },
    button: {
        backgroundColor: '#6c387a',
        width: '100%',
        padding: 15,
        borderRadius: 5,
        alignItems: 'center',
    },
    buttonOutline: {
        backgroundColor: 'white',
        borderColor: '#6c387a',
        borderWidth: 2,
        width: '100%',
        padding: 15,
        borderRadius: 5,
        alignItems: 'center',
        marginTop: 10,
    },
    buttonText: {
        color: 'white',
        fontWeight: '700',
        fontSize: 16,
    },
    buttonOutlineText: {
        color: '#6c387a',
        fontWeight: '700',
        fontSize: 16,
    },
    homeLogo: {
        width: '45%',
        height: undefined,
        aspectRatio: 205 / 152,
        marginBottom: 20,
    },
})
